import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { GlobalsService } from 'src/app/shared/services/globals';
import { Alert } from '../../../models/alert.model';
import { SieniService } from 'src/app/shared/services/sieni.service';
import { PdaService } from 'src/app/shared/services/pda.service';
import { LoadingService } from 'src/app/shared/components/loading/loading.service';

@Component({
  selector: 'app-members-modal',
  templateUrl: './members-modal.component.html',
  styleUrls: ['./members-modal.component.scss'],
})
export class MembersModalComponent implements OnInit {
  @Input() title: any;
  @Input() from: string;
  @Input() data: any[];
  @Input() leaderSelected: any[];
  @Input() guestSelected: any[];
  loading: boolean = false;
  content: string;
  datosFormulario: FormGroup;
  users: any = [];
  grupos: any = [];
  checkedUser: any = [];
  checkedGroup: any = [];
  @Output() public emitActionPlanData = new EventEmitter();

  @Output() clickClose = new EventEmitter();
  @Output() clickDismiss = new EventEmitter();
  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private modalService: NgbModal,
    private globals: GlobalsService,
    private _sieni_service: SieniService,
    private _pda: PdaService,
    private _loading: LoadingService
  ) {}

  ngOnInit(): void {
    this.getMembers();
  }
  btnClose() {
    let data = {
      users: this.users.filter((x) => x.checked),
      grupos: this.checkedGroup,
    };
    this.clickClose.emit(data);
    this.activeModal.close();
  }

  btnDismiss() {
    this.clickDismiss.emit('dismiss');
    this.activeModal.dismiss();
  }

  checkUser(event, user, from) {
    let fromWhere;
    if (from == 'user') {
      fromWhere = this.checkedUser;
    } else if ((from = 'group')) {
      fromWhere = this.checkedGroup;
    }
    if (event.target.checked == true) {
      fromWhere.push(user);
    } else {
      fromWhere.map((el, index) => {
        if (el.id == user.id) {
          fromWhere.splice(index, 1);
        }
      });
    }
  }
  getMembers() {
    this.loading = true;
    this._sieni_service.getOrganizationUsers().subscribe((data) => {
      this.users = data;
      this.users.map((x) => {
        if (this.from == 'lider') {
          for (let i = 0; i < this.leaderSelected.length; i++) {
            if (x.id == this.leaderSelected[i].user_id) {
              x.checked = true;
            }
          }
        } else if (this.from == 'guest') {
          for (let i = 0; i < this.guestSelected.length; i++) {
            if (x.id == this.guestSelected[i].user_id) {
              x.checked = true;
            }
          }
        }
      });
      this._pda.getGrupos().subscribe((data: any) => {
        this.grupos = data.data;
        this.grupos.map((x) => {
          x.checked = false;
        });
        this.loading = false;
      });
    });
  }
}
